import { render, staticRenderFns } from "./WidgetComponent.vue?vue&type=template&id=f32b9aea"
import script from "./WidgetComponent.vue?vue&type=script&lang=js"
export * from "./WidgetComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports